export default "__VITE_ASSET__B27te$bq__"